<template>
  <div class="tutorial-guide">
    <swiper ref="tutorialGuide" :options="swiperOption">
      <swiper-slide>
        <Slide1 :props="{ background: background }">
          <template #bottomMenu>
            <CoachMarkBottomSheet />
            <CoachMarkBottomMenu active-menu="Home" isShowTooltip />
          </template>
          <v-footer height="50px" dark></v-footer>
        </Slide1>
      </swiper-slide>
      <swiper-slide>
        <Slide2 :props="{ background: background }">
          <template #bottomMenu>
            <CoachMarkBottomSheet open />
            <CoachMarkBottomMenu active-menu="Home" />
          </template>
          <v-footer height="50px" dark></v-footer>
        </Slide2>
      </swiper-slide>
      <swiper-slide>
        <Slide3>
          <template #bottomMenu>
            <CoachMarkBottomMenu active-menu="Library" />
          </template>
          <v-footer height="50px" dark></v-footer>
        </Slide3>
      </swiper-slide>
<!--      <swiper-slide>-->
<!--        <Slide4 />-->
<!--      </swiper-slide>-->
      <swiper-slide>
        <Slide7>
          <template #bottomMenu>
            <CoachMarkBottomMenu active-menu="Mission" />
          </template>
          <v-footer height="50px" dark></v-footer>
        </Slide7>
      </swiper-slide>
      <swiper-slide>
        <Slide5>
          <template #bottomMenu>
            <CoachMarkBottomMenu active-menu="Square" />
          </template>
          <v-footer height="50px" dark></v-footer>
        </Slide5>
      </swiper-slide>
      <swiper-slide>
        <Slide6>
          <template #bottomMenu>
            <CoachMarkBottomMenu active-menu="Travel" />
          </template>
          <v-footer height="50px" dark></v-footer>
        </Slide6>
      </swiper-slide>
    </swiper>
    <div class="coach-bottom-controller">
      <div class="swiper-pagination" slot="pagination"></div>
      <template v-if="beginner">
        <v-btn plain text color="white"
               v-if="activeIndex === 5"
               class="btn-app-start"
               @click="$emit('close')">시작하기</v-btn>
      </template>
      <template v-else>
        <v-btn plain text color="white"
               class="btn-app-start"
               @click="$emit('close')">닫기</v-btn>
      </template>
    </div>
  </div>
</template>

<script>

// eslint-disable-next-line no-unused-vars
let vm = null

import { swiper, swiperSlide, directive } from 'vue-awesome-swiper'
import {mixinAuth} from '@/mixins'
import CoachMarkBottomMenu from './CoachMarkBottomMenu.vue'
import CoachMarkBottomSheet from './CoachMarkBottomSheet.vue'
import Slide1 from './slides/Slide1.vue'
import Slide2 from './slides/Slide2.vue'
import Slide3 from './slides/Slide3.vue'
// import Slide4 from './slides/Slide4.vue' // 찐한대화
import Slide5 from './slides/Slide5.vue'
import Slide6 from './slides/Slide6.vue'
import Slide7 from './slides/Slide7.vue' // 미션
export default {
  name: 'TutorialIndex',
  components: {
    swiper,
    swiperSlide,
    CoachMarkBottomMenu,
    CoachMarkBottomSheet,
    Slide1,
    Slide2,
    Slide3,
    // Slide4,
    Slide5,
    Slide6,
    Slide7
  },
  directives: {
    swiper: directive
  },
  mixins: [mixinAuth],
  props: {
    beginner: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    activeIndex: 0,
    swiperOption: {
      initialSlide: 0,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: false
      },
      on: {
        slideChange: function () {
          vm.activeIndex = this.activeIndex
        }
      }
    },
  }),
  computed: {
    background () {
      if (this.isSamsungFire) {
        return 'background/hill/day.png';
      } else {
        return 'background/space/day_ezn.gif';
      }
    },
  },
  created () {
    vm = this
  },
  mounted () {
    console.log(window.$('#ch-plugin'))
    window.$('#ch-plugin').css({'z-index': 7})
  }
}
</script>
<style lang="css" src="swiper/dist/css/swiper.min.css"></style>
<style lang="scss" src="@/assets/sass/page/_coach-mark.scss" scoped></style>
